import { render } from "./DxIcon.vue?vue&type=template&id=b9e7e0dc&scoped=true"
import script from "./DxIcon.vue?vue&type=script&lang=js"
export * from "./DxIcon.vue?vue&type=script&lang=js"

import "./DxIcon.vue?vue&type=style&index=0&id=b9e7e0dc&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9e7e0dc"]])

export default __exports__